<template>
    <div class="list-style" ref="list">

        <div @click="goDetail(1)" class="go-detail"/>

        <el-image :src="onlineOrderFoodImage" fit="cover" class="pic" lazy v-if="onlineOrderFoodImage!=='' ">
            <div slot="error" class="image-slot"/>
        </el-image>

        <!--TODO 數字或+號-->
        <div class="sticker-text" :class="{'border': isOpenFast}">
            <el-button class="sticker-btn" :class="takeAmount <= 0 ? 'b2': 'b1'" @click="openAmount" type="text" v-if="!isOpenFast">
                <template v-if="takeAmount <= 0">+</template>
                <span v-else />
            </el-button>
            <template v-else>
                <el-button class="sticker-btn b3" @click.stop="numberCalculate('dec')" type="text">
                    <template v-if="takeAmount > 1">-</template>
                    <template v-else><i class="el-icon-delete"/></template>
                </el-button>
                <el-button class="sticker-btn b3" @click.stop="numberCalculate('add')" type="text">+</el-button>
            </template>
            <span class="num" v-if="takeAmount > 0">{{takeAmount}}</span>
        </div>

        <div class="content">
            <h4>{{onlineOrderName}}</h4>
            <p class="detail mt-2" v-html="onlineOrderDescription"></p>
            <p class="detail yellow mt-2" v-html="onlineOrderEspeciallyRemark"></p>
            <div class="red fee mt-2">
                <!--TODO 有降價才出現-->
                <p v-if="price > onlineOrderPrice" class="original">${{price}}</p>
                ${{onlineOrderPrice}}
            </div>
        </div>
    </div>
</template>

<script>

import * as constDefine from "@/store/constDefine";
import Analytics from '@/util/analytics';
    export default {
        name: "Menu",
        props: {
            item: {},
            takeAmount: {type: Number, default: 0},
            storeId: {required: false, type: Number, default: 0},
            takeoutId: {required: false, type: Number, default: 0},
        },
        data() {
            return {
                posFoodId: 0,
                posFoodName: '',
                price: '',
                onlineOrderName: '',
                onlineOrderPrice: '',
                onlineOrderFoodImage: '',
                onlineOrderDescription: '',
                onlineOrderEspeciallyRemark: '',
                isCordova: this.$public.isCordova(),
                isOnlineOrder: Boolean(sessionStorage.getItem("isOnlineOrder")),
                dataObject: {},
                isOpenFast: false,
                isMounted: false,
            }
        },
        created() {
            this.setupData();
        },
        mounted() {
            document.addEventListener("click", this.handleOutsideClick);
            this.isMounted = true
        },
        watch: {
            item() {
                this.setupData();
            },
            "takeAmount": {
                handler(val) {
                    if (val > 0 && this.isMounted && this.item.isEmptyNote) {
                        this.isOpenFast = true
                    } else if (val <= 0) {
                        this.isOpenFast = false
                    }
                },
                deep: true,
                immediate: true,
            },
        },
        methods: {
            setupData() {
                this.posFoodId = this.item.posFoodId;
                this.posFoodName = this.item.posFoodName;
                this.price = this.item.price;
                this.onlineOrderName = this.item.onlineOrderName;
                this.onlineOrderPrice = this.item.onlineOrderPrice;
                this.onlineOrderFoodImage = this.item.onlineOrderFoodImage;
                this.onlineOrderDescription = this.item.onlineOrderDescription;
                this.onlineOrderEspeciallyRemark = this.item.onlineOrderEspeciallyRemark;
            },
            goDetail(trigger = 0) {//該函數名字不要動，因為父組件會呼叫
                let analyticsPage = '';
                if (this.isCordova || this.isOnlineOrder) {
                    this.$router.push({
                        name: 'OrderDetail',
                        query: {'id': this.posFoodId},
                        params: {storeId: this.storeId, takeoutId: this.takeoutId}
                    });
                    analyticsPage = 'OnlineOrder';
                } else {
                    this.dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
                    this.dataObject = {
                        ...this.dataObject, ...{
                            "posFoodId": this.posFoodId,
                            "takeoutId": this.takeoutId,
                        }
                    }
                    sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(this.dataObject));
                    this.$router.push({name: 'OrderDetail'});
                    if (this.dataObject.isTableOrderAddItem) {
                        analyticsPage = 'QRCodeOrder';
                    } else {
                        analyticsPage = 'TableOrder';
                    }
                }
                if (trigger === 1) {
                    this.analytics = Analytics.getInstance(this.$route, analyticsPage);
                    this.analytics.recordViewed(this.posFoodId, 'clicked');
                }
            },
            openAmount() {
                if (this.takeAmount > 0) {
                    this.$emit('triggerEvent', {
                        "event": "updateAmount",
                        "action": "openAmount",
                        "posFoodId": this.posFoodId,
                    });
                } else {
                    this.numberCalculate('add')
                }
            },
            numberCalculate(val) {
                if (val === 'dec') {
                    this.$emit('triggerEvent', {
                        "event": "updateAmount",
                        "action": "decAmount",
                        "posFoodId": this.posFoodId,
                    });
                } else {
                    this.$emit('triggerEvent', {
                        "event": "updateAmount",
                        "action": "addAmount",
                        "posFoodId": this.posFoodId,
                    });
                }
            },
            handleOutsideClick() {
                this.isOpenFast = false
            },
        },
        beforeDestroy() {
            document.removeEventListener("click", this.handleOutsideClick);
        },
    }
</script>

